import type {Fila} from '@/hooks/sgsst/riesgos/use-ipevr'

export type Opcion = {id: string; name: string}

export type FiltrosDePersonas = {
  empleados: Set<string>
  cargos: Set<string>
  areas: Set<string>
}

// Los cargos salen de todas las filas, importadas o de entrevista: `fila.cargos` ya junta los dos orígenes.
export function opcionesDeCargo(filas: Fila[]): Opcion[] {
  const nombres = new Set<string>()
  for (const fila of filas) for (const cargo of fila.cargos) nombres.add(cargo)
  return Array.from(nombres)
    .sort((a, b) => a.localeCompare(b))
    .map((name) => ({id: name, name}))
}

export function coincideConFiltrosDePersonas(fila: Fila, {empleados, cargos, areas}: FiltrosDePersonas): boolean {
  if (cargos.size > 0 && !fila.cargos.some((cargo) => cargos.has(cargo))) return false
  if (empleados.size === 0 && areas.size === 0) return true
  return fila.origen_empleados.some(
    (e) => (empleados.size === 0 || empleados.has(e.id)) && (areas.size === 0 || e.areas.some((a) => areas.has(a)))
  )
}
